import type { CenterTypeEnum, ProfessionalTypeEnum } from '@gql/graphql';
import type {
  DetailListContactData,
  DetailListProPracticalData,
  DetailListScheduleData,
  HeaderProfileData,
  RelatedLinksData,
  SlideshowData,
} from '@presentation/components';
import type { LocationDescriptor } from 'history';
import type { MouseEventHandler, ReactElement, RefObject } from 'react';

export interface ProPageServiceItem {
  name: string;
  onClick?: () => void;
  price?: string;
  duration?: string;
  isSpecialist?: boolean;
}

export type ProPageServicesSection = Array<{
  title: string;
  items: Array<ProPageServiceItem>;
}>;

export interface ProItemData {
  slideshow?: SlideshowData;
  description?: string;
  extraDescription?: string;
  wellnessEngagement?: string;
  addressCoordinates?: {
    lng: number;
    lat: number;
  };

  onlineBookingEnabled?: boolean;
  proType?: ProfessionalTypeEnum;
  proCenterType?: CenterTypeEnum;
  city?: string;
  unclaimedLink?: LocationDescriptor;
  contactInfo?: DetailListContactData;
}
export interface ProPageData {
  header?: HeaderProfileData;
  BookingForm?: ReactElement;
  practicalInfo?: DetailListProPracticalData;
  isUnclaimed?: boolean;
  isTipawPartner?: boolean;
  contactInfo?: DetailListContactData;
  onShowContactInfo?: () => void;
  showContactInfo?: boolean;
  serviceSections?: ProPageServicesSection;
  showOverlay?: boolean;
  onOverlayClick?: MouseEventHandler;
  onSideCardClick?: MouseEventHandler;
  relatedLinks?: RelatedLinksData;
  proSchedule?: DetailListScheduleData;
  shopSchedule?: DetailListScheduleData;
  urgencyAvailabilities?: DetailListScheduleData;
  tipawPartnerRef: RefObject<HTMLDivElement>;
  enableWhatsAppContact?: boolean;
  onWhatsappClick: () => void;
}

export interface ProPageProps extends ProPageData, ProItemData {}
